import DateTimeField from "components/Ui/DateTimeField/DateTimeField";

/**
 * One end of the order pages' date range, bound to the URL.
 *
 * The filters live in the query string so a filtered view can be bookmarked or
 * shared, which is the only thing this adds over DateTimeField — see there for
 * why these are not native date inputs and what a picked day means.
 *
 * @param {object} props
 * @param {"startDate"|"endDate"} props.paramKey - Which bound this field owns.
 * @param {string} props.label
 * @param {URLSearchParams} props.searchParams
 * @param {Function} props.setSearchParams
 * @param {Function} [props.onApplied] - Reset pagination to the first page.
 */
const DateTimeFilter = ({ paramKey, label, searchParams, setSearchParams, onApplied }) => {
    const apply = (next) => {
        if (next) {
            searchParams.set(paramKey, next);
        } else {
            searchParams.delete(paramKey);
        }

        setSearchParams(searchParams);
        onApplied?.();
    };

    return (
        <div className="col">
            <h6>{label}</h6>
            <DateTimeField
                value={searchParams.get(paramKey) || ""}
                onChange={apply}
                edge={paramKey === "endDate" ? "end" : "start"}
            />
        </div>
    );
};

export default DateTimeFilter;
